import React, { useEffect, useState } from 'react';

const NUM_STARS = 80;

function randomBetween(a, b) {
  return Math.random() * (b - a) + a;
}

function createStar() {
  return {
    left: randomBetween(0, 100),
    top: randomBetween(0, 100),
    size: randomBetween(1, 3),
    speed: randomBetween(0.02, 0.08), // velocidad de caída
    opacity: randomBetween(0.3, 1),
    twinkle: randomBetween(2, 5), // duración del parpadeo
    phase: Math.random() * Math.PI * 2, // desfase para el parpadeo
  };
}

const CosmicBackground = () => {
  const [stars, setStars] = useState(() => Array.from({ length: NUM_STARS }, createStar));

  useEffect(() => {
    let animationFrame;
    const animate = () => {
      setStars(prevStars => prevStars.map(star => {
        let newTop = star.top + star.speed;
        if (newTop > 100) {
          // Reinicia la estrella arriba
          return { ...createStar(), top: 0 };
        }
        return { ...star, top: newTop };
      }));
      animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const now = Date.now();

  return (
    <div className="cosmic-bg">
      {stars.map((star, i) => {
        // Parpadeo suave usando seno
        const twinkle = 0.7 + 0.3 * Math.sin((now / 1000) * (2 * Math.PI / star.twinkle) + star.phase);
        const style = {
          left: `${star.left}vw`,
          top: `${star.top}vh`,
          width: `${star.size}px`,
          height: `${star.size}px`,
          opacity: star.opacity * twinkle,
          position: 'absolute',
          background: 'white',
          borderRadius: '50%',
          pointerEvents: 'none',
          transition: 'opacity 0.3s',
        };
        return <div className="star" style={style} key={i} />;
      })}
    </div>
  );
};

export default CosmicBackground; 